import { ITemplatesHistory } from "interfaces";
import { DEFAULT_TEMPLATE_DETAILS } from "constants/TemplateEditor";

export const initialState: ITemplatesHistory = {
  templates: {
    data: [],
    groups: [],
    loading: true,
  },
  documentTypes: {
    data: [],
    loading: false,
  },
  template: {
    data: DEFAULT_TEMPLATE_DETAILS,
    newTemplateId: -1,
    isSaveAs: false,
    loading: false,
    saving: false,
  },
  initTemplate: {
    data: DEFAULT_TEMPLATE_DETAILS,
    saving: false,
  },
  templateCopy: {
    data: null,
    loading: false,
    completed: false,
  },
  confirmExitModal: {
    visible: false,
    location: {},
  },
  selectedTemplateId: -1,
  templateVersions: {
    data: [],
    loading: true,
  },
};
